<template>
  <v-dialog v-model="computedDialog" max-width="500px" @keydown.esc="close" persistent>
    <v-card>
      <v-card-title>
        <span class="text-h6">Create New Line</span>
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="editedItem.Line_Name"
          label="Line Name"
          autofocus
          density="compact"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="save"
          :disabled="!editedItem.Line_Name || loading"
          :loading="loading"
          class="pr-5"
        >
          <v-icon start>mdi-content-save-outline</v-icon>Save
        </v-btn>
        <v-btn
          color="secondary"
          @click="close"
          :disabled="loading"
          class="pr-4"
        >
          <v-icon start>mdi-close</v-icon>Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex'
import ADD_LINE from '@/graphql/Line/addLine.gql'

export default {
  name: 'AddLineDialog',
  emits: ['update:dialog', 'line-created'],
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    brandFk: {
      type: Number,
      required: false,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      editedItem: {
        Line_Name: '',
        Brand_FK: null
      }
    }
  },
  computed: {
    computedDialog: {
      get () {
        return this.dialog
      },
      set (value) {
        this.$emit('update:dialog', value)
      }
    }
  },
  watch: {
    dialog (val) {
      if (val) {
        // Reset form when dialog opens
        this.editedItem = {
          Line_Name: '',
          Brand_FK: this.brandFk
        }
      }
    },
    brandFk (newVal) {
      this.editedItem.Brand_FK = newVal
    }
  },
  methods: {
    ...mapMutations(['addError']),

    save () {
      if (!this.editedItem.Line_Name || !this.editedItem.Brand_FK) {
        this.addError('Line Name and Brand are required')
        return
      }

      this.loading = true

      this.$apollo.mutate({
        mutation: ADD_LINE,
        variables: {
          AddLineInput: {
            Line_Name: this.editedItem.Line_Name,
            Brand_FK: this.editedItem.Brand_FK
          }
        },
        update: (cache, { data: { addLine } }) => {
          // Add new line to the cached allLines array (works regardless of query variables)
          cache.modify({
            fields: {
              allLines(existingLines = [], { toReference }) {
                const newLineRef = toReference(addLine)
                return [...existingLines, newLineRef]
              }
            }
          })
          // Set initial mutation log count on the new line
          cache.modify({
            id: `Line:${addLine.Line_SK}`,
            fields: {
              Mutation_Logs_Count() {
                return 1
              }
            }
          })
        }
      })
        .then((data) => {
          // Emit the created line to parent
          this.$emit('line-created', data.data.addLine)
          this.close()
        })
        .catch((error) => {
          this.addError(error.message || 'Failed to create line')
        })
        .finally(() => {
          this.loading = false
        })
    },

    close () {
      this.$emit('update:dialog', false)
      setTimeout(() => {
        this.editedItem = {
          Line_Name: '',
          Brand_FK: null
        }
      }, 300)
    }
  }
}
</script>

<style scoped>
</style>
